<template>
  <div>
    <el-tabs v-model="seachStatus" @tab-click="handleClick">
      <el-tab-pane label="待整改" name="待整改"> </el-tab-pane>
      <el-tab-pane label="已整改" name="已整改"> </el-tab-pane>
    </el-tabs>

    <div>
      <el-dialog title="添加报修" :visible.sync="addShow" width="680px">
        <el-form :inline="true" ref="formPost" :model="formPost" label-width="95px">
          <el-form-item
            label="报修人："
            prop="bdRepairName"
            :rules="[{ required: true, message: '请输入报修人' }]"
          >
            <el-input
              size="small"
              v-model="formPost.bdRepairName"
              placeholder="报修人"
              clearable=""
            ></el-input>
          </el-form-item>
          <el-form-item
            label="联系电话："
            prop="phone"
            :rules="[{ required: true, message: '请输入' }]"
          >
            <el-input
              size="small"
              v-model="formPost.phone"
              placeholder="联系电话"
              clearable=""
            ></el-input>
          </el-form-item>
          <el-form-item
            label="报修项目："
            prop="repairItem"
            :rules="[{ required: true, message: '请输入' }]"
          >
            <el-input
              size="small"
              v-model="formPost.repairItem"
              placeholder="报修项目"
              clearable=""
            ></el-input>
          </el-form-item>
          <el-form-item
            label="上报时间："
            prop="repairTime"
            :rules="[{ required: true, message: '请选择' }]"
          >
            <el-date-picker
              clearable
              size="small"
              v-model="formPost.repairTime"
              type="date"
              value-format="yyyy-MM-dd HH:mm:ss"
              placeholder="选择时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item
            label="故障区域："
            prop="faultArea"
            :rules="[{ required: true, message: '请输入' }]"
          >
            <el-input
              size="small"
              v-model="formPost.faultArea"
              placeholder="故障区域"
              clearable=""
            ></el-input>
          </el-form-item>
          <el-form-item
            label="故障阐述："
            prop="faultDesc"
            :rules="[{ required: true, message: '请输入' }]"
          >
            <el-input
              size="small"
              v-model="formPost.faultDesc"
              placeholder="故障阐述"
              clearable=""
            ></el-input>
          </el-form-item>
          <el-form-item label="照片上传：">
            <el-upload
              ref="uploadFile"
              action="/api/admin/dutyInfo/uploadFile"
              name="file"
              :before-upload="beforeUpload"
              :file-list="fileList"
              :headers="headerData"
              :on-success="onSuccess"
              :show-file-list="false"
            >
              <el-button size="small" type="primary">点击上传</el-button>
            </el-upload>

            <div
              v-for="(item, index) in fileList"
              :key="index"
              style="
                color: #3c98ff;
                cursor: pointer;
                display: flex;
                justify-content: space-between;
              "
            >
              <div @click="down(item.name, item.url)">{{ item.name }}</div>
              <div @click="delUrl(index)"><i class="el-icon-delete"></i></div>
            </div>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="addShow = false">取 消</el-button>
          <el-button type="primary" @click="ok">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="派单" :visible.sync="toNextShow" width="400px">
        <div style="text-align: center">
          <span>工程师：</span>
          <el-select size="small" v-model="userId" placeholder="请选择工程师" filterable>
            <el-option
              v-for="item in userList"
              :key="item.userId"
              :label="item.userName"
              :value="item.userId"
            ></el-option>
          </el-select>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="toNextShow = false" size="small">取 消</el-button>
          <el-button type="primary" @click="nextSubmit" size="small">确 定</el-button>
        </span>
      </el-dialog>
      <el-dialog title="报修详情" :visible.sync="show" width="600px">
        <det :row="row"></det>
        <el-divider></el-divider>
        <div>
          <el-steps
            :active="
              row.status == '待派单'
                ? 1
                : row.status == '已派单'
                ? 2
                : row.status == '已完成'
                ? 3
                : 1
            "
            align-center
          >
            <el-step title="待派单" :description="setTime(row.repairTime)"></el-step>
            <el-step title="已派单" :description="setTime(row.assignerTime)"></el-step>
            <el-step title="已完成" :description="setTime(row.finishTime)"></el-step>
          </el-steps>
        </div>
      </el-dialog>
      <el-form :inline="true" :model="form" class="demo-form-inline">
        <el-form-item label="巡检人">
          <el-input
            size="small"
            v-model="form.bdRepairName"
            placeholder="巡检人"
            clearable=""
          ></el-input>
        </el-form-item>

        <el-form-item label="巡检项目">
          <el-input
            size="small"
            v-model="form.repairItem"
            placeholder="巡检项目"
            clearable=""
          ></el-input>
        </el-form-item>
        <el-form-item label="状态" v-if="seachStatus == '待整改'">
          <el-select size="small" v-model="form.status" placeholder="派单状态">
            <el-option label="全部" value="待整改"></el-option>
            <el-option label="待整改" value="待整改"></el-option>
            <el-option label="已整改" value="已整改"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="报修日期" prop="queryDate">
          <el-date-picker
            clearable
            size="small"
            v-model="queryDate"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>

        <!-- <el-form-item label="所属部门">
                    <el-select size="small" v-model="form.deptId" placeholder="所属部门" disabled>
                        <el-option v-for="item in depitList" :index="item.deptId" :label="item.deptName" :value="item.deptId"></el-option>
                    </el-select>
                </el-form-item> -->
        <!-- <el-form-item label="完成日期" prop="queryDate">
                                <el-date-picker clearable size="small" v-model="queryDate" type="daterange" align="right"
                                    unlink-panels range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
                                    value-format="yyyy-MM-dd">
                                </el-date-picker>
                            </el-form-item> -->

        <el-form-item>
          <el-button size="small" type="primary" @click="query()">查询</el-button>
          <!-- <el-button v-show="seachStatus == '未完成'" size="small" type="primary" @click="addRepair()">新增</el-button> -->
        </el-form-item>
        <div style="float: right;margin-right: 20px;">
            <el-button @click="exportData" size="small" type="warning">导出</el-button>
        </div>
      </el-form>
      <div>{{ sum }}</div>
      <el-table :data="data" style="width: 100%">
        <!-- <el-table-column type="index" label="序号" width="60" align="center"></el-table-column> -->
        <el-table-column
          prop="bdRepairName"
          label="巡检人"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="deptName"
          label="所属部门"
          align="center"
        ></el-table-column>
        <el-table-column prop="phone" label="联系电话" align="center"></el-table-column>
        <el-table-column
          prop="repairItem"
          label="巡检项目"
          align="center"
        ></el-table-column>
        <el-table-column prop="repairTime" label="上报时间" align="center">
          <template slot-scope="{ row }">{{ row.repairTime.split("T")[0] }} </template>
        </el-table-column>
        <el-table-column prop="faultArea" label="问题区域" align="center">
        </el-table-column>
        <el-table-column prop="faultDesc" label="问题描述" align="center">
        </el-table-column>
        <el-table-column prop="status" label="状态" align="center"></el-table-column>
        <el-table-column
          prop="assignerName"
          label="指派人"
          align="center"
        ></el-table-column>
        <el-table-column prop="date" label="操作" align="center">
          <template slot-scope="{ row }">
            <el-button type="text" @click="viewRow(row)"> 查看</el-button>
            <span v-hasPermi="['repair:public:edit']">
              <el-button v-if="row.status == '待派单'" type="text" @click="toNext(row)"
                >派单</el-button
              >
            </span>
            <!-- <span v-hasPermi="['repair:public:delete']">
                            <el-button v-if="row.status == '已派单'" type="text" @click="editStatus(row)">完成</el-button>
                             <el-button  v-if="row.status == '待派单'" type="text" @click="delRow(row)">删除</el-button>
                              </span> -->
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        v-if="totalNum > 0"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="form.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
var dayjs = require("dayjs");
import det from "../engineering/repair/det.vue";
export default {
  components: {
    det,
  },
  data() {
    return {
      userList: [],
      rowId: "",
      toNextShow: false,
      userId: "",
      seachStatus: "待整改",
      queryDate: [],
      fileList: [],
      fileNameList: [],
      filePathList: [],
      headerData: {
        Authorization: localStorage.access_token,
      },
      formPost: {
        bdRepairName: "", //报修人
        phone: "", //报修电话
        faultArea: "", //故障区域
        repairItem: "", //报修项目
        repairTime: "", //shijian
        faultDesc: "", //故障描述
        appendixA: "", //附件
      },
      roleId: sessionStorage.roleId,
      user: "", //派单选择的工人
      users: [],
      show: false,
      data: [],
      reason: null,
      row: {},
      form: {
        status: "待整改",
        bdRepairName: "",
        deptId: 116,
        repairTime: null,
        finishTime: null,
        faultArea: "",
        repairItem: "",
        currentPage: 1,
        pageSize: 10,
        enterBy: null, //创建人userId
        assignerId: null, //指派工程师userId
      },
      totalNum: 0,
      addShow: false,
      depitList: [],
      sum: "",
    };
  },
  methods: {
    getDepitList() {
      this.$http.get(`/api/bdPaRepairApply/getDepts`).then((res) => {
        if (res.data.code == 0) {
          this.depitList = res.data.data;
        } else {
        }
      });
    },
    down(name, url) {
      let a = document.createElement("a");
      a.href = url;
      a.click();
      // downloadFile(url)
    },
    delUrl(index) {
      this.fileNameList.splice(index, 1);
      this.filePathList.splice(index, 1);
      this.fileList.splice(index, 1);
    },
    addRepair() {
      this.fileNameList = [];
      this.filePathList = [];
      this.fileList = [];
      this.formPost = {
        bdRepairName: "", //报修人
        phone: "", //报修电话
        faultArea: "", //故障区域
        repairItem: "", //报修项目
        repairTime: null, //shijian
        faultDesc: "", //故障描述
        appendixA: "", //附件
      };
      this.addShow = true;
    },
    toNext(row) {
      this.rowId = row.id;
      this.userId = "";
      this.toNextShow = true;
    },
    nextSubmit() {
      // this.rowId;
      // this.userId = ""
      if (this.userId == "") {
        this.$message.error("请选择工程师");
        return;
      }
      this.$http
        .post(`/api/bdPaRepairApply/updateRepairStatus`, {
          assignerId: this.userId,
          id: this.rowId,
          assignerTime: this.currentTime(),
          status: "已派单",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.toNextShow = false;
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    delRow(row) {
      this.$confirm("确定删除该数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$http
            .delete(`/api/bdPaRepairApply/deleteRepairItem?id=${row.id}`, {})
            .then((res) => {
              if (res.data.code == 0) {
                this.$message.success(res.data.message);
                this.getAll();
              } else {
                this.$message.error(res.data.message);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    query() {
      this.form.currentPage = 1;
      this.form.pageSize = 10;
      this.getAll();
    },
    handleClick() {
      this.form.status = this.seachStatus;
      this.queryDate = [];
      this.form.bdRepairName = "";
      this.form.repairTime = null;
      this.form.finishTime = null;
      this.form.deptId = 116;
      this.form.faultArea = "";
      this.form.repairItem = "";
      this.form.currentPage = 1;
      this.form.pageSize = 10;
      this.getAll();
    },
    // 导出
    exportData() {
      this.$http
        .post(
          `/api/export/xunjian`,
          {
             ...this.form
          },
          {
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json;charset=utf-8",
            },
            responseType: "blob",
          }
        )
        .then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], {
            type: "application/vnd.ms-excel",
          });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          link.download = "合同数据.xls";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
    },
    editStatus(row) {
      this.$http
        .post(`/api/bdPaRepairApply/updateRepairStatus`, {
          status: "已完成",
          id: row.id,
          finishTime: this.currentTime(),
          assignerTime: null,
          assignerId: "",
          appendixB: "",
        })
        .then((res) => {
          if (res.data.code == 0) {
            this.$message.success(res.data.message);
            this.getAll();
          } else {
            this.$message.error(res.data.message);
          }
        });
    },

    ok() {
      this.$refs.formPost.validate((valid) => {
        if (valid) {
          if (this.filePathList.length != 0) {
            this.formPost.appendixA = this.filePathList.toString(); //附件
          }
          this.$http
            .post(`/api/bdPaRepairApply/addRepairApply`, this.formPost)
            .then((res) => {
              if (res.data.code == 0) {
                this.addShow = false;
                this.$message.success(res.data.message);
                this.getAll();
              } else {
                this.$message.error(res.data.message);
              }
            });
        }
      });
    },
    handleCurrentChange(val) {
      this.form.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.form.pageSize = val;
      this.getAll();
    },
    viewRow(row) {
      this.row = row;
      if (row.appendixA) {
        this.row.showPathList = row.appendixA.split(",");
      }
      if (row.appendixB) {
        this.row.showPathList2 = row.appendixB.split(",");
      }
      if (row.status == "未派单") {
      }
      if (row.status == "已派单") {
      }
      if (row.status == "已完成") {
      }
      this.show = true;
    },
    getAll() {
      if (this.queryDate && this.queryDate.length == 2) {
        this.form.repairTime = this.queryDate[0];
        this.form.finishTime = this.queryDate[1];
      } else {
        this.form.repairTime = null;
        this.form.finishTime = null;
      }
      this.$http.post(`/api/bdPaRepairApply/queryPaRepairApply`, this.form).then((r) => {
        console.log(r);
        if (r.data.code == 0) {
          this.data = r.data.data.items;
          this.totalNum = r.data.data.totalNum;
          this.sum = r.data.data.sum;
        } else {
          this.data = [];
          this.totalNum = 0;
        }
      });
    },
    getUsers() {
      this.$http
        .get(`/api/system/role/authUser/allocatedList`, {
          params: {
            roleId: 13,
          },
        })
        .then((res) => {
          this.userList = res.data.rows;
        });
    },
    beforeUpload(file, fileList) {
      // console.log(file.name.split(".")[0])
      // console.log(this.fileList)
      let status = true;
      this.fileNameList.forEach((element) => {
        if (file.name.split(".")[0] == element) {
          status = false;
        }
      });
      if (!status) {
        this.$message.error(`${file.name.split(".")[0]}文件已存在！`);
      }
      return status;
    },
    onSuccess(response, file, fileList) {
      // this.detailFileList(fileList);
      if (response.code == "0") {
        // this.form.filePath = fileList[0].response.data.filePath;
        // this.form.fileName = fileList[0].response.data.fileName;
        this.fileNameList.push(file.name.split(".")[0]);
        this.filePathList.push(response.data);
        this.fileList.push({
          name: file.name.split(".")[0],
          url: response.data,
          uid: file.uid,
        });
        // this.form.files = [res.data]
        this.$message.success("上传成功");
      } else {
        this.$message.error("上传失败");

        //上传失败不显示列表文件
        let uid = file.uid;
        this.clearShowList(uid);
        this.clearFileList(uid);
      }
    },
    // 删除临时文件
    fileRemove(file) {
      this.clearFileList(file.uid);
    },
    //下面两个方法是重点
    //清空文件列表
    clearFileList(uid) {
      let fileListIdx = this.fileList.findIndex((item) => item.uid === uid);
      this.fileList.splice(fileListIdx, 1);
    },
    //清空显示列表
    clearShowList(uid) {
      let idx = this.$refs["uploadFile"].uploadFiles.findIndex(
        (item) => item.uid === uid
      );
      this.$refs.uploadFile.uploadFiles.splice(idx, 1);
    },
    down(name, url) {
      let a = document.createElement("a");
      a.href = url;
      a.click();
      // downloadFile(url)
    },
    delUrl(index) {
      this.fileNameList.splice(index, 1);
      this.filePathList.splice(index, 1);
      this.fileList.splice(index, 1);
    },

    currentTime() {
      var date = new Date();
      var year = date.getFullYear(); //月份从0~11，所以加一
      let month = date.getMonth();
      console.log("month", month);
      var dateArr = [
        date.getMonth() + 1,
        date.getDate(),
        date.getHours(),
        date.getMinutes(),
        date.getSeconds(),
      ];
      //如果格式是MM则需要此步骤，如果是M格式则此循环注释掉
      for (var i = 0; i < dateArr.length; i++) {
        if (dateArr[i] >= 1 && dateArr[i] <= 9) {
          dateArr[i] = "0" + dateArr[i];
        }
      }
      return (
        year +
        "-" +
        dateArr[0] +
        "-" +
        dateArr[1] +
        " " +
        dateArr[2] +
        ":" +
        dateArr[3] +
        ":" +
        dateArr[4]
      );
    },
  },
  mounted() {
    this.getAll();
    this.getUsers();
    this.getDepitList();
  },
};
</script>

<style></style>
